import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";

import { ButtonComponentModule } from "../../components/button/button.module";
import { FooterComponentModule } from "../../components/footer/footer-component.module";

import { NotFoundPageRoutingModule } from "./not-found-routing.module";
import { NotFoundPage } from "./not-found.page";

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    NotFoundPageRoutingModule,

    ButtonComponentModule,
    FooterComponentModule,
  ],
  declarations: [NotFoundPage],
})
export class NotFoundPageModule {}
